const CARDS_API_PATH = "/cards";

export const CARDS_API_ENDPOINTS = {
  GET_CARDS: CARDS_API_PATH,
  LOCK_CARD: `${CARDS_API_PATH}/:cardId/lock`,
  UNLOCK_CARD: `${CARDS_API_PATH}/:cardId/unlock`,
  ACTIVATE_CARD: `${CARDS_API_PATH}/:cardId/activate`,
  GET_PIN_CARD: `${CARDS_API_PATH}/:cardId/pin`,
};
